export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welcome in! Here's your recent history and remaining credits."])},
        "share-button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Share this page"])},
        "share-button-done": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["URL copied!"])}
      },
      "ja": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ダッシュボード"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ようこそう！このページにはランキング追跡と残っているランキングポイントが見えています。"])},
        "share-button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このページを共有する"])},
        "share-button-done": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ＵＲＬコピーした!"])}
      }
    }
  })
}
